var collapsible_list_pair_rtlignore_default = {
  "container": "NnuxD",
  "title": "JqgMy",
  "viewerContainer": "uVfFQ",
  "titleContainer": "HX-lE",
  "content": "y0mKT",
  "expandIcon": "REa3o",
  "dndIcon": "FK8hz",
  "RTL": "XiOh6",
  "LTR": "BHm-y",
  "itemContainer": "FEf2P",
  "itemContainerViewer": "QtFNa",
  "mouseDown": "mGpPR",
  "innerEditor": "D7e8A",
  "item": "zt7oY",
  "floatingAddPluginMenuWrapper": "px6mu"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
